module.exports = __webpack_public_path__ + "img/FOLDESIGN.7e38d5d6.png";